import { Link } from 'react-router-dom';
import { ArrowRight, Sparkles } from 'lucide-react';
import { MPD_META } from '../data/premierDepartData';

export const PremierDepartHomeSection = () => (
  <section className="px-4 sm:px-6 py-10" data-testid="mpd-home-section">
    <div className="max-w-6xl mx-auto rounded-3xl overflow-hidden border border-orange-500/25 bg-gradient-to-br from-[#2a1c0e] to-[#1a1208]">
      <div className="grid md:grid-cols-2 items-center">
        <div className="p-7 sm:p-10">
          <p className="inline-flex items-center gap-1.5 text-[10.5px] font-black uppercase tracking-[0.22em] text-orange-400 mb-3">
            <Sparkles size={13} /> Nouveau · dès 14 ans
          </p>
          <h2 className="text-2xl sm:text-3xl font-black text-white leading-tight mb-3" style={{ fontFamily: 'Georgia, serif' }}>
            Mon premier départ
          </h2>
          <p className="text-[14px] text-white/70 leading-relaxed mb-5">
            Le livret pédagogique interactif pour découvrir le deux-roues et la voiturette : chapitres illustrés, checklists, quiz corrigés et suivi de progression. Gratuit et ouvert à tous.
          </p>
          <Link to="/mon-premier-depart" data-testid="mpd-home-section-cta"
            className="inline-flex items-center gap-2 px-5 h-11 rounded-full bg-orange-500 hover:bg-orange-400 text-black font-black text-sm transition-colors">
            Découvrir le livret <ArrowRight size={16} />
          </Link>
        </div>
        <img src={MPD_META.heroImage} alt="Mon premier départ — livret pédagogique dès 14 ans" className="w-full h-full object-cover min-h-[220px]" loading="lazy" />
      </div>
    </div>
  </section>
);

export default PremierDepartHomeSection;
